import { postRequest } from "./request";

export function BlockClient(dataObject) {
  const userData = JSON.parse(localStorage.getItem("userData"));
  return postRequest({
    path: `block-client`,
    token: userData.token,
    data: {
      c_id: dataObject,
    },
  }).then((response) => {
    return response ? response : undefined;
  });
}
